import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
//import reportWebVitals from './reportWebVitals';
import WebService from './webService/WebService'
import StateService from './webService/StateService'
import WebServiceContext from './webService/WebServiceContext'
import {BasicContextProvider} from './context/BasicContext'


const ws = new WebService();
const ss = new StateService();


ReactDOM.createRoot(
	document.getElementById('hib-dashboard') as HTMLElement
).render(
	<WebServiceContext.Provider value={{ webservice: ws, stateservice:ss }}>
		<BasicContextProvider>
			<App/>
		</BasicContextProvider>
	</WebServiceContext.Provider>
)
/*
ReactDOM.createRoot(
	document.getElementById('root') as HTMLElement
).render(
<React.StrictMode>
	<WebServiceContext.Provider value={{ webservice: ws }}>
		<App/>
	</WebServiceContext.Provider>
</React.StrictMode>
)
*/